/* Every word the shared layer shows, in one place.
 *
 * A component library ships its own strings ("No data", "Rows per page") and
 * scripts/check_copy.py cannot see them. Every shared component takes its
 * words from here, so the words a person reads are ours and the check reads
 * them. docs/design-standards.md, Words. */
export const STRINGS = {
  close: "Close",
  back: "Back",
  actions: "Actions",
  previous: "Previous",
  next: "Next",
  sortBy: "Sort by",
  sortAscending: "Low to high, A to Z",
  sortDescending: "High to low, Z to A",
  csv: "CSV",
  loading: "Loading.",
  openRecord: "Open the record",
  filters: "Filters",
  clearAll: "Clear all",
  done: "Done",
  cancel: "Cancel",
} as const;
